import { Dictionary } from "../../../../../react-core/Helpers/CommonHelper";
import { FirmType } from "../../../../../Wrap/Constants/Enums/Domain/FirmType";
import { FsaAuthorisationStatus } from "../../../../../Wrap/Constants/Enums/Domain/FsaAuthorisationStatus";
import { FsaType } from "../../../../../Wrap/Constants/Enums/Domain/FsaType";
import { MultiProductPermissions } from "../../../../../Wrap/Constants/Enums/Domain/MultiProductPermissions";
import { PensionArrangementType } from "../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { FcaTradingStatus } from "../../../../../Wrap/Constants/Enums/Network/FcaTradingStatus";
import { FileFormat } from "../../../../../Wrap/Models/Models/Company/FileFormat";
export const ContentFilter = {
    title: "Search criteria",
    search: "Search",
    processType: "Process type",
    firmType: "Firm type",
    firmName: "Firm name",
    reference: "FCA/Trading reference",
    postcode: "Postcode",
    createdBy: "Created by",
    dateStarted: "Date started",
    lastUpdated: "Last updated",
    from: "From",
    to: "To",
};

export const ContentTable = {
    noDataMsg: "No results have been found for the entered criteria.",
    dateStarted: "Date started",
    processType: "Process type",
    status: "Status",
    firmName: "Firm name",
    reference: "FCA/Trading reference",
    createdBy: "Created by",
    postCode: "Postcode",
    lastUpdated: "Last updated",
    action: "Action",
    view: "VIEW",
    resume: "RESUME",
    delete: "Delete",
    sessions: "SESSIONS",
    editNotes: "Edit Notes",
    defaultUrl: "#",
    save: "save",
    other: "Other",
    confirmDelete: "Are you sure you want to delete selected wizards?",
    noWizardSelected: "Please select wizard to delete",
};

export const NetworkContentTable = {
    header: {
        networkId: "Network ID",
        networkName: "Network Name",
        reference: "FCA/Trading Reference",
        postCode: "Postcode",
    },
};

export const CreatedbyOptions: Dictionary[] = [
    { key: 0, value: "Anyone" },
    { key: 1, value: "Me" },
];

export const ProcessTypeOptions: Dictionary[] = [
    { key: 0, value: "All" },
    { key: 1, value: "Create firm" },
    { key: 2, value: "Edit firm" },
];

export const FirmTypeOptions: Dictionary[] = [
    { key: 0, value: "All" },
    { key: 1, value: "Appointed representative" },
    { key: 2, value: "Directly authorised" },
    // { key: 3, value: "Third Party Bond" },
    // { key: 4, value: "Third Party Pension" },
];

export const StatusOptions: Dictionary[] = [
    { key: 0, value: "NotSpecified" },
    { key: 1, value: "Pending" },
    { key: 2, value: "Submitted" },
    { key: 3, value: "Cancelled" },
    { key: 4, value: "Active" },
    { key: 5, value: "Complete" },
    { key: 6, value: "AwaitingAuthorisation" },
];

export const stepperName = {
    stepOne: "Firm details",
    stepTwo: "Remuneration and valuation",
    stepThirdParty: "Alert",
    stepThree: "Validation & execute",
};

export const FirmTypeMap = {
    [FirmType.AppointedRepresentative]: "Appointed representative firm",
    [FirmType.DirectlyAuthorised]: "Directly authorised firm",
    [FirmType.Bond]: "Bond",
    [FirmType.Pension]: "Pension",
};

export const FsaTypArrays = [FsaType.Fcaregistered, FsaType.Offshoreregistered, FsaType.Eearegistered];

export const FsaTypeMap = {
    [FsaType.Fcaregistered]: "FCA registered",
    [FsaType.Offshoreregistered]: "Offshore registered",
    [FsaType.Eearegistered]: "EEA registered",
};

export const FsaAuthorisationStatusMap = {
    [FsaAuthorisationStatus.NotSpecified]: "",
    [FsaAuthorisationStatus.Authorised]: "Authorised",
    [FsaAuthorisationStatus.Deauthorised]: "De-authorised",
    [FsaAuthorisationStatus.Pendingauthorisation]: "Pending authorisation",
    [FsaAuthorisationStatus.Eeaauthorised]: "EEA authorised",
    [FcaTradingStatus.ClosedToNewBusiness]: "Closed to new business",
};

export const FcaTradingStatusMap = {
    [FcaTradingStatus.NotSpecified]: "",
    [FcaTradingStatus.Authorised]: "Authorised",
    [FcaTradingStatus.Deauthorised]: "De-authorised",
    [FcaTradingStatus.ClosedToNewBusiness]: "Closed to new business",
};

export const ProductPermissionsArrayMap = {
    options: [
        MultiProductPermissions.NotSpecified,
        MultiProductPermissions.PlatformCashAccount,
        MultiProductPermissions.PersonalPortfolio,
        MultiProductPermissions.IndividualSavingsAccount,
        MultiProductPermissions.JuniorIndividualSavingsAccount,
        MultiProductPermissions.SelfInvestedPersonalPension,
        MultiProductPermissions.JuniorSelfInvestedPersonalPension,
        MultiProductPermissions.OnshoreBond,
        MultiProductPermissions.OffshoreBond,
        MultiProductPermissions.Pension,
    ],
    optionsMap: {
        [MultiProductPermissions.NotSpecified]: "Not specified",
        [MultiProductPermissions.PlatformCashAccount]: "Cash account",
        [MultiProductPermissions.PersonalPortfolio]: "Personal Portfolio",
        [MultiProductPermissions.IndividualSavingsAccount]: "Individual Savings Account (ISA)",
        [MultiProductPermissions.JuniorIndividualSavingsAccount]: "Junior Individual Savings Account (JISA)",
        [MultiProductPermissions.SelfInvestedPersonalPension]: "Self-Invested Personal Pension (SIPP)",
        [MultiProductPermissions.JuniorSelfInvestedPersonalPension]: "Junior Self-Invested Personal Pension (JSIPP)",
        [MultiProductPermissions.OnshoreBond]: "Onshore Bond",
        [MultiProductPermissions.OffshoreBond]: "Offshore Bond",
        [MultiProductPermissions.Pension]: "Aberdeen SIPP",
    },
};

export const SubAccountTypeArrayMap = {
    options: [
        SubAccountType.NotSpecified,
        SubAccountType.Sipp,
        SubAccountType.StocksIsa,
        SubAccountType.InvestmentAccount,
        SubAccountType.Npr,
        SubAccountType.WrapCash,
    ],
    optionsMap: {
        [SubAccountType.NotSpecified]: "Not specified",
        [SubAccountType.Sipp]: "Self-Invested Personal Pension (SIPP)",
        [SubAccountType.StocksIsa]: "Individual Savings Account (ISA)",
        [SubAccountType.InvestmentAccount]: "Personal Portfolio",
        [SubAccountType.Npr]: "Aberdeen SIPP",
        [SubAccountType.WrapCash]: "Cash Account",
        [SubAccountType.CashIsa]: "Cash ISA",
        [SubAccountType.AuAccumulation]: "AuAccumulation",
        [SubAccountType.AuPension]: "AuPension",
        [SubAccountType.Pension]: "Pension",
        [SubAccountType.OffshoreBond]: "Offshore Bond",
        [SubAccountType.OnshoreBond]: "Onshore Bond",
        [SubAccountType.CashAccount]: "Cash Account",
        [SubAccountType.RetailSipp]: "Retail SIPP",
        [SubAccountType.PersonalPortfolio]: "Personal Portfolio",
        [SubAccountType.RetailSipp]: "Retail SIPP",
        [SubAccountType.RetailBond]: "Retail Bond",
        [SubAccountType.Pep]: "Pep",
        [SubAccountType.OrsoRa]: "OrsoRa",
        [SubAccountType.OrsoSa]: "OrsoSa",
        [SubAccountType.JuniorIsa]: "Junior ISA",
        [SubAccountType.JuniorSipp]: "Junior SIPP",
        [SubAccountType.Pr]: "Pr",
    },
    colorClassNameMap: {
        [SubAccountType.PersonalPortfolio]: "pp",
        [SubAccountType.StocksIsa]: "isa",
        [SubAccountType.Sipp]: "sipp",
        [SubAccountType.WrapCash]: "wrap-cash",
        [SubAccountType.OffshoreBond]: "offshore-bond",
        [SubAccountType.OnshoreBond]: "onshore-bond",
        [SubAccountType.CashIsa]: "cash-isa",
        [SubAccountType.JuniorIsa]: "junior-isa",
        [SubAccountType.JuniorSipp]: "junior-sipp",
        [SubAccountType.Npr]: "sipp",
    },
    totalColorClassName: "total",
};

export const PensionArrangementTypeArrayMap = {
    options: [
        PensionArrangementType.NotSpecified,
        PensionArrangementType.Accumulation,
        PensionArrangementType.Crystallised,
    ],
    optionsmap: {
        [PensionArrangementType.NotSpecified]: "Not pecified",
        [PensionArrangementType.Accumulation]: "Pre-retirement",
        [PensionArrangementType.Crystallised]: "Post-retirement",
    },
};

export const BulkEnquiryFileFormatArrayMap = {
    options: [FileFormat.Csv],
    optionsMap: {
        [FileFormat.Csv]: "CSV",
    },
};
